/* Royal SJ Group — motion & interaction core (self-contained, no deps) */
(function () {
  'use strict';
  if (window.__rsjCore) return;
  window.__rsjCore = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- scroll reveal with per-group stagger ---------- */
  function initReveals(root) {
    var els = (root || document).querySelectorAll('.rsj-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduced) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );
    els.forEach(function (el, i) {
      if (!el.style.getPropertyValue('--rsj-delay')) {
        var group = el.closest('[data-rsj-stagger]');
        if (group) {
          var siblings = Array.prototype.slice.call(group.querySelectorAll('.rsj-reveal'));
          el.style.setProperty('--rsj-delay', Math.min(siblings.indexOf(el), 10) * 70 + 'ms');
        }
      }
      io.observe(el);
    });
  }

  /* ---------- gentle parallax for [data-rsj-parallax="0.2"] ---------- */
  function initParallax() {
    if (reduced) return;
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-rsj-parallax]'));
    if (!els.length) return;
    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var speed = parseFloat(el.getAttribute('data-rsj-parallax')) || 0.15;
        var offset = (r.top + r.height / 2 - vh / 2) * speed;
        el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
      });
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  /* ---------- 3D tilt on hover for [data-rsj-tilt] ---------- */
  function initTilt() {
    if (reduced || !window.matchMedia('(hover: hover)').matches) return;
    document.addEventListener('pointermove', function (e) {
      var card = e.target.closest && e.target.closest('[data-rsj-tilt]');
      if (!card) return;
      var r = card.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      card.style.transform = 'perspective(800px) rotateX(' + (-y * 5).toFixed(2) + 'deg) rotateY(' + (x * 5).toFixed(2) + 'deg) translateY(-4px)';
    });
    document.addEventListener('pointerout', function (e) {
      var card = e.target.closest && e.target.closest('[data-rsj-tilt]');
      if (card) card.style.transform = '';
    });
  }

  /* ---------- AJAX add to cart for form.rsj-atc-form ---------- */
  var toast;
  function showToast(message, isError) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'rsj-toast';
      toast.setAttribute('role', 'status');
      toast.innerHTML =
        '<span class="rsj-toast__check"><svg width="11" height="9" viewBox="0 0 11 9" fill="none"><path d="M1 4.5L4 7.5L10 1" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg></span>' +
        '<span class="rsj-toast__msg"></span>' +
        '<a href="/cart">View cart</a>';
      document.body.appendChild(toast);
    }
    toast.querySelector('.rsj-toast__msg').textContent = message;
    toast.querySelector('a').style.display = isError ? 'none' : '';
    toast.querySelector('.rsj-toast__check').style.background = isError ? '#b3543e' : '';
    toast.classList.add('is-on');
    clearTimeout(toast.__t);
    toast.__t = setTimeout(function () { toast.classList.remove('is-on'); }, 3500);
  }

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* One cart read, shared with the drawer's own in-flight request when possible. */
  function fetchCart() {
    var items = document.querySelector('cart-items-component');
    if (items && typeof items.fetchCartData === 'function') {
      try { return Promise.resolve(items.fetchCartData()); } catch (err) { /* fall through */ }
    }
    return fetch(cartRoot() + 'cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (r) { return r.json(); });
  }

  /* Integrates with the theme's cart system: dispatches CartLinesUpdateEvent so the
     cart drawer auto-opens and re-renders, exactly like the theme's own product form.
     Resolves to the same module instance the theme's importmap uses. */
  var eventsModulePromise = null;
  function themeEvents() {
    if (!eventsModulePromise) {
      try {
        eventsModulePromise = import('https://cdn.shopify.com/storefront/standard-events.js');
      } catch (err) {
        eventsModulePromise = Promise.reject(err);
      }
    }
    return eventsModulePromise.catch(function () { return null; });
  }
  /* load it while the page is idle so the first click never waits on the network */
  function warmThemeEvents() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(function () { themeEvents(); }, { timeout: 3000 });
    } else {
      setTimeout(themeEvents, 1500);
    }
  }

  /* open the theme's cart drawer, whatever the theme's auto-open setting is */
  function openCartDrawer() {
    var drawerComponent = document.querySelector('cart-drawer-component');
    var drawer = drawerComponent && drawerComponent.closest('theme-drawer');
    if (!drawer || typeof drawer.open !== 'function') {
      window.location.href = cartRoot() + 'cart';
      return;
    }
    /* wait a frame so the drawer's contents are re-rendered before it slides in */
    requestAnimationFrame(function () {
      if (!drawer.isOpen) drawer.open();
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form.rsj-atc-form');
    if (!form || !window.fetch) return;
    e.preventDefault();
    /* no button animation — the cart drawer opening is the confirmation */
    if (form.__rsjBusy) return;
    form.__rsjBusy = true;

    var fd = new FormData(form);
    /* the form carries the variant's minimum order quantity, not a blind 1 */
    var qty = Number(fd.get('quantity')) || 1;

    /* ask Shopify to render the cart drawer sections in the same response */
    var sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
    });
    if (sectionIds.length) fd.set('sections', sectionIds.join(','));

    /* fire the add immediately — nothing waits on the events module */
    var addPromise = fetch(cartRoot() + 'cart/add.js', {
      method: 'POST',
      body: fd,
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin'
    }).then(function (r) { return r.json(); });
    addPromise.catch(function () {});

    themeEvents().then(function (mod) {
      var CartLinesUpdateEvent = mod && mod.CartLinesUpdateEvent;
      var deferred = null;
      if (CartLinesUpdateEvent && CartLinesUpdateEvent.createPromise) {
        deferred = CartLinesUpdateEvent.createPromise();
        document.dispatchEvent(new CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: String(fd.get('id')), quantity: qty }],
          promise: deferred.promise
        }));
      }

      addPromise
        .then(function (json) {
          if (json.status) throw new Error(json.description || json.message || 'Could not add — try again');

          return fetchCart().then(function (cart) {
            if (deferred) {
              deferred.resolve({
                cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
                detail: {
                  items: cart.items,
                  source: 'product-form-component',
                  sourceId: form.id || 'rsj-atc',
                  itemCount: qty,
                  productId: form.dataset.productId,
                  sections: json.sections,
                  didError: false
                }
              });
              /* the drawer re-renders from the event above; now slide it open */
              openCartDrawer();
            } else {
              /* no theme events available: the drawer can't refresh, so show the cart page */
              window.location.href = cartRoot() + 'cart';
            }
            form.__rsjBusy = false;
            document.dispatchEvent(new CustomEvent('rsj:cart:updated', { detail: cart }));
          });
        })
        .catch(function (err) {
          if (deferred) deferred.reject(err);
          form.__rsjBusy = false;
          showToast((err && err.message) || 'Could not add — try again', true);
        });
    });
  });

  /* ---------- carousel rails: arrows, progress thumb, drag-to-scroll ---------- */
  /* nearest ancestor that actually scrolls vertically (the theme's .page-wrapper
     on desktop, the document everywhere else) */
  function pageScroller(from) {
    var node = from.parentElement;
    while (node) {
      var cs = getComputedStyle(node);
      if (/(auto|scroll)/.test(cs.overflowY) && node.scrollHeight > node.clientHeight + 1) return node;
      node = node.parentElement;
    }
    return document.scrollingElement || document.documentElement;
  }
  function initRails(root) {
    (root || document).querySelectorAll('[data-rsj-rail]').forEach(function (wrap) {
      if (wrap.__rsjRail) return;
      wrap.__rsjRail = true;
      var rail = wrap.querySelector('.rsj-rail');
      if (!rail) return;
      var prev = wrap.querySelector('[data-rail-prev]');
      var next = wrap.querySelector('[data-rail-next]');
      var track = wrap.querySelector('[data-rail-track]');
      var thumb = wrap.querySelector('[data-rail-thumb]');

      function step() {
        var card = rail.firstElementChild;
        if (!card) return rail.clientWidth * 0.8;
        var gap = parseFloat(getComputedStyle(rail).columnGap) || 14;
        return card.getBoundingClientRect().width + gap;
      }
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: reduced ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: reduced ? 'auto' : 'smooth' }); });

      function sync() {
        var max = rail.scrollWidth - rail.clientWidth;
        var p = max > 2 ? rail.scrollLeft / max : 0;
        if (track && thumb) {
          track.style.visibility = max > 2 ? 'visible' : 'hidden';
          var range = track.clientWidth - thumb.clientWidth;
          thumb.style.transform = 'translateX(' + (p * range).toFixed(1) + 'px)';
        }
        if (prev) prev.toggleAttribute('disabled', rail.scrollLeft < 8);
        if (next) next.toggleAttribute('disabled', max > 2 ? rail.scrollLeft > max - 8 : true);
      }
      rail.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();

      /* vertical wheel over the rail must scroll the PAGE, never get trapped.
         On desktop the theme sets html/body to overflow:hidden and scrolls
         .page-wrapper instead, so walk up to the real scroller — window.scrollBy
         would be a no-op there. */
      rail.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
          e.preventDefault();
          var dy = e.deltaY;
          if (e.deltaMode === 1) dy *= 16;            /* lines -> px (Firefox) */
          else if (e.deltaMode === 2) dy *= window.innerHeight; /* pages -> px */
          var sc = pageScroller(rail);
          try {
            /* 'instant' overrides the theme's scroll-behavior:smooth so every tick lands */
            sc.scrollTo({ top: sc.scrollTop + dy, behavior: 'instant' });
          } catch (err) {
            sc.scrollTop += dy;
          }
        }
      }, { passive: false });

      /* drag to scroll with the mouse — a press only becomes a drag once the
         pointer really moves, so plain clicks on links and buttons always land */
      var down = false, dragging = false, suppress = false, startX = 0, startL = 0;
      function endDrag() {
        down = false;
        if (dragging) {
          dragging = false;
          rail.classList.remove('is-dragging');
        }
      }
      rail.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        /* controls keep their own behaviour — never start a drag from them */
        if (e.target.closest('button, input, select, textarea, label, form')) return;
        down = true; dragging = false; suppress = false;
        startX = e.clientX; startL = rail.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (!dragging) {
          if (Math.abs(dx) < 6) return;
          dragging = true;
          suppress = true;
          rail.classList.add('is-dragging');
        }
        rail.scrollLeft = startL - dx;
      });
      window.addEventListener('pointerup', endDrag);
      window.addEventListener('pointercancel', endDrag);
      window.addEventListener('blur', endDrag);
      /* links and images are natively draggable; that would cancel our drag */
      rail.addEventListener('dragstart', function (e) { e.preventDefault(); });
      rail.addEventListener('click', function (e) {
        if (suppress) { e.preventDefault(); e.stopPropagation(); }
        suppress = false;
      }, true);
    });
  }

  /* ---------- count-up numbers: <span data-rsj-count="1000" data-rsj-suffix="+"> ---------- */
  function formatNum(n) {
    return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function initCounters(root) {
    var els = (root || document).querySelectorAll('[data-rsj-count]:not(.is-done)');
    if (!els.length) return;
    function run(el) {
      el.classList.add('is-done');
      var target = parseFloat(el.getAttribute('data-rsj-count')) || 0;
      var suffix = el.getAttribute('data-rsj-suffix') || '';
      if (reduced) { el.textContent = formatNum(target) + suffix; return; }
      var t0 = null, dur = 1400;
      function tick(ts) {
        if (!t0) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 4);
        el.textContent = formatNum(target * eased) + (p === 1 ? suffix : '');
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { run(en.target); io.unobserve(en.target); }
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- cursor-follow glow: [data-rsj-glow] gets --mx/--my ---------- */
  function initGlow() {
    if (reduced || !window.matchMedia('(hover: hover)').matches) return;
    document.querySelectorAll('[data-rsj-glow]').forEach(function (el) {
      if (el.__rsjGlow) return;
      el.__rsjGlow = true;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
        el.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
      }, { passive: true });
    });
  }

  /* ---------- boot (also re-boot inside Shopify theme editor) ---------- */
  function boot() {
    initReveals(document);
    initParallax();
    initTilt();
    initRails(document);
    initCounters(document);
    initGlow();
    warmThemeEvents();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { initReveals(e.target); initRails(e.target); initCounters(e.target); initGlow(); });
})();
